import { render, staticRenderFns } from "./Layout2p1.vue?vue&type=template&id=779b611e&scoped=true&"
import script from "./Layout2p1.vue?vue&type=script&lang=js&"
export * from "./Layout2p1.vue?vue&type=script&lang=js&"
import style0 from "./Layout2p1.vue?vue&type=style&index=0&id=779b611e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b611e",
  null
  
)

export default component.exports